export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=f8f58e14&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/materials/materials-white-label/index.vue?vue&type=template&id=f8f58e14&
// module id = 1515
// module chunks = 0